import { Directive, OnInit, OnDestroy } from '@angular/core';
// import { EventEmitter, Output, Input } from '@angular/core';
import { Subscription } from 'rxjs';

import { SharingModuleService } from './sharingModule.service';

@Directive({
  selector: '[sharing-module]'
})
export class SharingModuleDirective implements OnInit, OnDestroy {

    private columnSortedSubscription: Subscription;

  constructor(private sortService: SharingModuleService) {}

    ngOnInit() {
    }

    ngOnDestroy() {
    }
}
